import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { isIosMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconArrowDown, IconEnlarge } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { exitPiP, showPiP } from '../../actions';
import { shouldShowPiP } from '../../functions';
import logger from '../../logger';
/**
 * 电脑浏览器工具栏：进入 / 退出系统画中画小窗。
 */
class PiPButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.pip';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.exitPip';
    icon = IconArrowDown;
    toggledIcon = IconEnlarge;
    label = 'toolbar.pip';
    toggledLabel = 'toolbar.exitPip';
    tooltip = 'toolbar.pip';
    toggledTooltip = 'toolbar.exitPip';
    /**
     * @inheritdoc
     */
    _isToggled() {
        return this.props._isPiPActive;
    }
    /**
     * 点击切换画中画（带用户手势，浏览器侧更易成功）。
     *
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _isPiPActive } = this.props;
        sendAnalytics(createToolbarEvent('toggle.pip', {
            enable: !_isPiPActive
        }));
        dispatch(setOverflowMenuVisible(false));
        if (_isPiPActive) {
            logger.info(`[画中画] ${new Date().toISOString()} 工具栏点击：退出画中画`);
            dispatch(exitPiP());
            return;
        }
        logger.info(`[画中画] ${new Date().toISOString()} 工具栏点击：进入画中画`);
        dispatch(showPiP());
    }
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const isPiPActive = Boolean(state['features/pip']?.isPiPActive);
    return {
        _isPiPActive: isPiPActive,
        // iOS Safari 工具栏空间紧、且移动头栏另有入口，避免重复展示。
        visible: shouldShowPiP(state) && !isIosMobileBrowser()
    };
}
export default translate(connect(mapStateToProps)(PiPButton));
